export const WALLET_PASS_LINK_TYPE = {
  EMERGENCY_REFERENCE: 'emergency-reference'
};
